import {
  getStoredToken,
  isTokenExpired,
  clearAuthAndRedirectToLogin,
  clearStoredAuth,
} from "../utils/auth";

/** Auth routes that must work even when a stale token is in localStorage. */
export const PUBLIC_AUTH_PATHS = [
  "/api/auth/login",
  "/api/auth/signup",
  "/api/auth/googleLogin",
  "/api/auth/send-reset-otp",
  "/api/auth/reset-password",
];

export function isPublicAuthRequest(url) {
  if (!url) return false;
  const path = url.replace(/^https?:\/\/[^/]+/, "").split("?")[0];
  return PUBLIC_AUTH_PATHS.some((p) => path === p || path.endsWith(p));
}

/**
 * Apply auth headers / stale-token handling to an outgoing request config.
 * @throws {Error} When a protected request has an expired token.
 */
export function prepareRequestConfig(config) {
  const next = { ...config, headers: { ...(config.headers || {}) } };
  const token = getStoredToken();
  const isPublicAuth = isPublicAuthRequest(next.url);

  if (!token) {
    delete next.headers.Authorization;
    return next;
  }

  if (isTokenExpired(token)) {
    if (isPublicAuth) {
      clearStoredAuth();
      delete next.headers.Authorization;
      return next;
    }

    clearAuthAndRedirectToLogin();
    throw new Error("Token expired");
  }

  if (isPublicAuth) {
    delete next.headers.Authorization;
    return next;
  }

  next.headers.Authorization = `Bearer ${token}`;
  return next;
}
